import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { AccountService } from '../account.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { AccountDetails } from './account-details.model';
import { UtilService } from 'app/core/services/util.service';

import { SessionService } from 'app/core/services/session.service';
import { RxComponent } from 'app/core/components/common/rx.component';

import { MiddlemanService } from 'app/core/services/middleman.service';
import { RemoveCreditApplicationComponent } from 'app/agora/components/account-data/accounts/details/remove-credit-application/remove-credit-application.component';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { TranslateService } from 'app/core/services/translate.service';

@Component({
    selector: 'itpx-account-details',
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.css']
})
export class AccountDetailsComponent extends RxComponent implements OnInit {

    private details: AccountDetails;
    private sub: Subscription;
    private id: string;
    private printLogoSrc: string;
    private brandedLogoSrc: string;
    private isInProgress: boolean = false;
    private defaultImage: string;
    private xmlIconUrl: string;
    private hasSmtpDetails: boolean;
    private userGroups: Array<any>;

    private mainFields: Array<any> = [];
    private adressesFields: Array<any> = [];
    private additionalFields: Array<any> = [];
    private smtpFields: Array<any> = [];
    private gmailSmtpFields = [];
    private segmentsFields: Array<any> = [];
    private fieldsPrintLogo: Array<any> = [];
    private fieldsBrandedLogo: Array<any> = [];
    private fieldsPricelist: Array<any> = [];
    private financeFields: Array<any> = [];
    private sellerFields: Array<any> = [];
    private sellerProceedsFields: Array<any> = [];
    private catalogFields: Array<any> = [];
    private accountFeaturesFields: Array<any> = [];
    private buttons: Array<any> = [
        {
            title: 'Edit',
            action: 'edit',
            icon: 'fa-pencil-square',
            class: 'btn-primary',
            disabled: false
        }, {
            title: 'Invite Employees',
            action: 'invite',
            icon: 'fa-envelope-open',
            class: 'btn-default',
            disabled: false
        }
    ];

    isSeller: boolean = false;

    constructor(
        private accountService: AccountService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private utilService: UtilService,
        private sessionService: SessionService,
        private middlemanService: MiddlemanService,
        private modalService: SmartModalService,
        private translateService: TranslateService
    ) {
        super();
        this.defaultImage = this.configService.get('images').defaultImage;
    }

    ngOnInit() {

        this.details = new AccountDetails();
        this.xmlIconUrl = this.configService.get('aws').downloadUrl +
            this.configService.get('images').xmlIcon

        this.fetchDetails();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(body: any) {
        let details = <AccountDetails>body.data;
        this.isSeller = details['seller'];
        let accountGroups = details['accountGroups'] || [];
        details['accountAccreditations'] = accountGroups.slice().filter(item => {
            return item.configType == 'account-accreditations-type';
        });
        details['accountSegments'] = accountGroups.slice().filter(item => {
            return item.configType == 'account-segments-type';
        });
        details['accountSellerSegments'] = accountGroups.slice().filter(item => {
            return item.configType == 'seller-managed-segments-type';
        });
        details['accountComputedSegments'] = accountGroups.slice().filter(item => {
            return item.configType == 'computed-account-segments-type';
        });

        let pricelistUrl = this.constructSphinxUrl(details);
        details['pricelistUrl'] = pricelistUrl;
        this.details = details;
        this.setSellerDetails();

        if (this.details.printLogo == null || this.details.printLogo.length == 0) {
            this.printLogoSrc = this.defaultImage;
        } else {
            this.printLogoSrc = this.details.printLogo;
        }

        if (this.details.brandedPortalLogo == null || this.details.brandedPortalLogo.length == 0) {
            this.brandedLogoSrc = this.defaultImage;
        } else {
            this.brandedLogoSrc = this.details.brandedPortalLogo;
        }

        if (this.details['paymentTerm'] && this.details['paymentTerm'].configKey == '100-dpr' && (this.buttons.filter(button => button.action === 'creditCardSegment').length == 0)) {
            this.buttons.push({
                title: 'Add Credit Card Segment',
                action: 'creditCardSegment',
                icon: 'fa-credit-card',
                class: 'btn-default',
                disabled: false
            })
        }

        this.hasSmtpDetails = details.smtpDetails.length > 0;
        //Bind finance credit details
        this.getCreditInfo(details);
    }
    private getCreditInfo(details: any) {
        let currencyCode = details['currency'].configKey;
        if (currencyCode != null) {
            let accountId = details['accountId'];
            this.accountService.getCreditDetails(accountId, currencyCode).subscribe(
                body => {
                    let creditData = body.data;
                    details['creditCurrency'] = creditData.creditCurrency;
                    details['available'] = creditData.available;
                    details['used'] = creditData.used;
                    details['limit'] = creditData.limit;
                });
        }
    }
    private onAction(action: string) {
        this.isInProgress = true;
        if (action == 'edit') {
            this.goToEditScreen();
        } else if (action == 'delete') {
            this.accountService.delete(this.details)
                .subscribe(
                    data => {
                        this.isInProgress = false;
                        this.notificationService.success(
                            'Successfully deleted Account ' + this.details.name,
                            'Success'
                        );
                        this.router.navigate(['/agora/account-data/accounts']);
                    },
                    error => this.isInProgress = false
                );
        } else if (action == 'invite') {
            this.accountService.invite(this.details)
                .subscribe(
                    body => {
                        this.notificationService.success('Successfully invited the employees for this account', 'Success');
                    }
                );
        } else if (action == 'credit') {
            this.middlemanService.navigateWithParams(['/agora/account-data/credit/add'], {}, { accountId: this.id });
        } else if (action == 'smtp_test') {

        } else if (action == 'removeCredit') {
            let result = this.modalService.open(RemoveCreditApplicationComponent, this.id, 'Remove Credit')
                .neverError()
                .bindToLifecycle(this)
                .subscribe(
                    data => {
                        if (data.result == 'success') {
                            this.router.navigate(['/agora/account-data/accounts']);
                        }
                    });
        } else if (action == 'creditCardSegment') {
            this.accountService.addCreditCardSegment({ id: this.details.id })
                .bindToLifecycle(this)
                .subscribe(
                    data => {
                        this.notificationService.success('Successfully added the credit card segment for this account', 'Success');
                        this.fetchDetails();
                    });
        } else {
            return false;
        }
    }
    private setSellerDetails() {
        let sellerAccount = this.details.sellerAccount;
        if (sellerAccount) {
            this.details.sellerAccount.proceeds = [
                {
                    label: 'Hosted',
                    min: sellerAccount.sellerProceedsMin,
                    max: sellerAccount.sellerProceedsMax,
                    percent: sellerAccount.sellerProceedsPercent
                },
                {
                    label: 'Non-Hosted',
                    min: sellerAccount.nonHostedSellerProceedsMin,
                    max: sellerAccount.nonHostedSellerProceedsMax,
                    percent: sellerAccount.nonHostedSellerProceedsPercent
                },
                {
                    label: 'Instructor',
                    min: sellerAccount.instructorSellerProceedsMin,
                    max: sellerAccount.instructorSellerProceedsMax,
                    percent: sellerAccount.instructorSellerProceedsPercent
                },
                {
                    label: 'Other',
                    min: sellerAccount.otherSellerProceedsMin,
                    max: sellerAccount.otherSellerProceedsMax,
                    percent: sellerAccount.otherSellerProceedsPercent
                }
            ]
        }
    }
    private constructSphinxUrl(data: any) {
        let result;
        if (data.bspBucket && data.bspKey) {
            result = this.configService.get('server').sphinx +
                this.configService.get('endpoints').sphinx.download.api +
                '/agora/' + data.bspBucket + '/' + data.bspKey;
        }
        return result;
    }
    private onEditSmtp() {
        this.router.navigate(['/agora/account-data/accounts', this.id, 'edit']);
    }

    private goToEditScreen() {
        let tab = this.route.snapshot.queryParams['tab'];
        this.router.navigate(['/agora/account-data/accounts', this.id, 'edit'], tab ? { queryParams: { tab: tab } } : {});
    }

    private onTabClick(e) {
        let tabId = e.srcElement.attributes['href'].value;
        this.router.navigate(
            ['/agora/account-data/accounts', this.id, 'details'],
            { queryParams: { tab: tabId.substr(1) } }
        );
    }

    private fetchDetails() {
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.accountService.getAccountDetails(this.id)
                .subscribe(
                    data => {
                        this.extractData(data);
                        this.fetchAccountFeaturesDetails();
                        this.mainFields = this.accountService.getDetailsMainFields("IN" === this.details.country);
                        this.adressesFields = this.accountService.getDetailsAddressesFields(this.details.domains[0].name);
                        this.additionalFields = this.accountService.getDetailsAdditionalFields();
                        this.smtpFields = this.accountService.getDetailsSmtpfields();
                        this.gmailSmtpFields = this.accountService.getGmailSmtpFields();
                        this.segmentsFields = this.accountService.getDetailsSegmentsFields();
                        this.fieldsPrintLogo = this.accountService.getDetailsPrintLogoFields();
                        this.fieldsBrandedLogo = this.accountService.getDetailsBrandedLogoFields();
                        this.fieldsPricelist = this.accountService.getDetailsPricelistFields();
                        this.financeFields = this.accountService.getDetailsFinanceFields();
                        this.sellerFields = this.accountService.getSellerAccountDetailsFields();
                        this.sellerProceedsFields = this.accountService.getSellerAccountProceedsDetailsFields();
                        this.catalogFields = this.accountService.getCatalogDetailsFields();
                        this.accountFeaturesFields = this.accountService.getAccountFeaturesFields();
                    }
                );
        });
        this.userGroups = this.sessionService.getUserGroups();

        if (this.userGroups && this.userGroups.indexOf('credit-application-owner') != -1 && (this.buttons.filter(button => button.action === 'credit').length == 0)) {
            this.buttons.push({
                title: this.translateService.translate('agora.account.details.manage-credit-button'),
                action: 'credit',
                icon: 'fa-money',
                class: 'btn-default',
                disabled: false
            },
                {
                    title: this.translateService.translate('agora.account.details.remove-credit-button'),
                    action: 'removeCredit',
                    icon: 'fa-times',
                    class: 'btn-danger',
                    disabled: false
                }
            )
        }
    }

    private fetchAccountFeaturesDetails() {
        this.accountService.fetchAccountFeaturesDetails(this.details.domains[0].name).subscribe(body => this.details['accountFeatures'] = body.data.features);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/details/account-details.component.ts